import { axiosInstanceChat } from './AxiosInstance';

// Get all chats for the current user
// `type` is 'DIRECT' or 'GROUP'. The API filters on it, so a page of 20
// is 20 of that kind; left out, every kind comes back together.
export const getUserChats = async (page = 1, limit = 20, search = '', type) => {
  try {
    const response = await axiosInstanceChat.get('/chats', {
      params: { page, limit, search, ...(type ? { type } : {}) },
    });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching chats', error);
    throw error;
  }
};

// Create a new chat
export const createChat = async (name, type, members) => {
  try {
    const response = await axiosInstanceChat.post('/chats', { name, type, members });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error creating chat', error);
    throw error;
  }
};

// Get messages for a specific chat
export const getChatMessages = async (chatId, limit = 50, offset = 0) => {
  try {
    const response = await axiosInstanceChat.get(`/messages/${chatId}/messages`, {
      params: { limit, offset },
    });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error fetching messages', error);
    throw error;
  }
};

// Send a message
export const sendMessage = async (chatId, content, type = 'TEXT', fileUrl = null) => {
  try {
    const payload = { content, type };
    if (fileUrl) payload.fileUrl = fileUrl;

    const response = await axiosInstanceChat.post(`/messages/${chatId}/messages`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error sending message', error);
    throw error;
  }
};

// Mark chat as read (optional, based on requirement)
export const markChatRead = async (chatId) => {
  try {
    const response = await axiosInstanceChat.put(`/chat-members/${chatId}/read`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error marking chat as read', error);
    throw error;
  }
};

// Delete a message
export const deleteMessage = async (messageId) => {
  try {
    const response = await axiosInstanceChat.delete(`/messages/${messageId}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error deleting message', error);
    throw error;
  }
};

// Edit a message
export const editMessage = async (messageId, content) => {
  try {
    const response = await axiosInstanceChat.put(`/messages/${messageId}`, { content });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error editing message', error);
    throw error;
  }
};

// Add members to a chat
export const addChatMembers = async (chatId, members) => {
  try {
    const response = await axiosInstanceChat.post(`/chats/${chatId}/members`, { members });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error adding members', error);
    throw error;
  }
};

// Remove members from a chat
export const removeChatMembers = async (chatId, members) => {
  try {
    // axios delete with body requires 'data' property
    const response = await axiosInstanceChat.delete(`/chats/${chatId}/members`, {
      data: { members },
    });
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error removing members', error);
    throw error;
  }
};

// Upload file
export const uploadFile = async (file, type = 'all') => {
  try {
    const formData = new FormData();
    formData.append('files', file);
    const response = await axiosInstanceChat.post(`/uploads?type=${type}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    // Return first file from the array as we upload one by one in UI
    return (response.data.data && response.data.data[0]) || response.data[0] || response.data;
  } catch (error) {
    console.error('Error uploading file', error);
    throw error;
  }
};

// Archive chat
export const archiveChat = async (chatId) => {
  try {
    const response = await axiosInstanceChat.put(`/chats/${chatId}/archive`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error archiving chat', error);
    throw error;
  }
};

// Unarchive chat
export const unarchiveChat = async (chatId) => {
  try {
    const response = await axiosInstanceChat.put(`/chats/${chatId}/unarchive`);
    return response.data.data || response.data;
  } catch (error) {
    console.error('Error unarchiving chat', error);
    throw error;
  }
};
